import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useDialog } from "../../hooks/store";
import { Divider } from "@mui/material";

export default function DialogProvider({ children }) {
  const {
    open,
    title,
    text,
    okCallback,
    canceleCallback,
    setDialog,
    closeDialog,
  } = useDialog();
  return (
    <>
      {children}
      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {text}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <button
            onClick={() => {
              canceleCallback();
              closeDialog();
            }}
            className="secondary">
            Покинуть
          </button>
          <button
            onClick={() => {
              okCallback();
              closeDialog();
            }}>
            Остаться
          </button>
        </DialogActions>
      </Dialog>
    </>
  );
}
